import { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'; // Import Router
import Header from './components/Header';
import ShowsList from './components/ShowsList';
import ShowDetails from './components/ShowDetails';
import LinksInformation from './components/LinksInformation'; // ✅ Import new page
import Footer from './components/Footer';
import EventManager from './components/EventManager';  // Import EventManager
import ShowListPage from './components/ShowsListPage'; // 👈 Import the new component
import { shows } from './data/shows';

function App() {
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (target.tagName === 'A' && target.getAttribute('href')?.startsWith('#')) {
        e.preventDefault();
        const id = target.getAttribute('href')?.substring(1);
        const element = document.getElementById(id || '');
        if (element) {
          window.scrollTo({
            top: element.offsetTop - 100,
            behavior: 'smooth'
          });
        }
      }
    };

    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);

  return (
    <Router>  {/* Wrap the entire app in Router */}
      <div className="bg-black text-gray-100 min-h-screen">
        <Header />
        <main className="container mx-auto px-4 py-12">
          <Routes>
            {/* Define your main route (default page) */}
            <Route
              path="/"
              element={
                <>
                  {/* <h2 className="text-4xl md:text-5xl font-bold mb-8 text-center text-red-600">Tour Dates</h2> */}
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-8" style={{ marginTop: -60 }}>
                    <div className="md:col-span-1">
                      <ShowsList shows={shows.filter(show => show.showInHome)} />
                    </div>
                    <div className="md:col-span-2">
                      {shows
                        .filter(show => show.showInHome)
                        .map((show) => (
                          <ShowDetails key={show.id} show={show} />
                        ))}
                    </div>

                  </div>
                </>
              }
            />
            {/* Define the route for EventManager */}
            <Route path="/manage-events" element={<EventManager shows={shows} onUpdateShows={() => { }} />} />
            <Route path="/showlist" element={<ShowListPage />} />
            <Route path="/links" element={<LinksInformation />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
